import { css } from '@emotion/react';
export const suggestionsContainerStyles = css`
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
  list-style: none;
  display: inline-block;
  position: relative;

  li:first-of-type {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
  }
  li:last-of-type {
    border-bottom-left-radius: inherit;
    border-bottom-right-radius: inherit;
  }
`;
export const suggestionButtonStyles = css`
  width: 100%;
  min-height: 40px;
  padding: ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}
    ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"};
  margin-top: 0px;
  border: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;

  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  gap: 13px;

  text-align: left;
  font-weight: 400;
  line-height: 18px;
  color: ${"var(--ds-text, #172b4d)"};
  font-family: inherit;
  font-size: inherit;

  background: none;

  &:not([disabled]) {
    cursor: pointer;

    &:active {
      background-color: ${"var(--ds-background-neutral-subtle-pressed, #091E4224)"};
    }

    &[data-highlighted='true'] {
      &:not(:active) {
        background-color: ${"var(--ds-background-neutral-subtle-hovered, #091E420F)"};
      }
    }

    &:focus {
      outline: 2px solid ${"var(--ds-border-focused, #4C9AFF)"};
      outline-offset: -2px;
    }
  }

  &[disabled] {
    background: ${"var(--ds-background-disabled, #091e420a)"};
    color: ${"var(--ds-text-disabled, #A5ADBA)"};
    cursor: not-allowed;
  }
`;
export const enterIconStyles = css`
  // with '&', the following selector applies only if this icon style is under a highlighted button
  button[data-highlighted='true'] & {
    display: inline;
  }

  display: none;
  padding: 5px 5px 3px 5px;
  border-radius: 3px;
  color: ${"var(--ds-text-subtle, #44546F)"};
  background-color: ${"var(--ds-background-neutral-subtle-hovered, #091E420F)"};
`;
export const suggestionListItemStyles = css`
  margin-top: 0px;
  list-style: none;
`;
export const suggestionLabelStyles = css`
  hyphens: auto;
  word-wrap: break-word;
  flex: 1;
  min-width: 90px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
export const tellAILabelStyles = css`
  font-weight: 500;
`;
export const suggestionsHeadingStyles = css`
  && {
    margin: 0px;
    padding: ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}
      ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"};
    font-size: 11px;
    line-height: 16px;
    font-weight: 700;
    text-transform: uppercase;
    color: ${"var(--ds-text-subtle, #42526E)"};
  }
`;
export const suggestionIconStyles = css`
  height: 24px;
  width: 24px;
  text-align: center;

  // Increase the size of default icon a little so it looks better
  & > .default-icon {
    height: 20px;
    width: 20px;
  }
`;
export const suggestionsScrollerStyles = css`
  max-height: 144px; // This was calculated with showing 3.5x items
  overflow-y: auto;
`;